import React, {useEffect, useState} from 'react';
import TapButton from "../components/TapButton";
import '../styles/pages/checklist.css';
import {Textarea} from '@mantine/core';
import ImageUploader from "../components/ImageUploader";
import Button from "../components/Button";
import Alert from "../components/Alert";
import {useLocation} from 'react-router-dom';
import {apiRequest} from "../utils/api";
import {useNavigate} from 'react-router-dom';

const Checklist = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const userInfo = JSON.parse(localStorage.getItem('user'));
    const userId = userInfo?.id;
    const tagnum = location.state?.tagnum;
    const ADDR = location.state?.storeInfo?.ADDR;
    console.log("ADDR :", ADDR);
    console.log("userId :", userId);

    // 체크리스트 상태 관리
    const [checklistData, setChecklistData] = useState({});
    const [checklistItems, setChecklistItems] = useState([]);
    const [notes, setNotes] = useState('');
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [alertState, setAlertState] = useState({isOpen: false, message: ''});
    const showAlert = (message) => {
        setAlertState({isOpen: true, message});
    };
    const closeAlert = () => {
        setAlertState({isOpen: false, message: ''});
    };

    useEffect(() => {
        if (tagnum) {
            fetchChecklist(tagnum); // tagnum으로 체크리스트 조회
        } else {
            showAlert("태그 정보가 없습니다.");
        }
    }, [tagnum]);

    const fetchChecklist = async (tagnum) => {
        try {
            const res = await apiRequest('/getChecklistByTag', 'POST', {TAGNUM: tagnum});

            if (res.success && Array.isArray(res.data)) {
                const newChecklistState = {};
                const items = [];

                res.data.forEach(item => {
                    const id = item.CHECK_ID;
                    newChecklistState[id] = {
                        checked: item.CHECKED === 'Y',
                        reason: item.REASON || ''
                    };

                    items.push({
                        id,
                        content: item.CONTENT,
                        hasTextarea: true,
                        showReasonText: true
                    });
                });

                setChecklistData(newChecklistState);
                setChecklistItems(items);
            } else {
                showAlert("체크리스트 데이터를 불러오지 못했습니다.");
            }
        } catch (error) {
            console.error("체크리스트 조회 오류:", error);
            showAlert("오류 발생");
        }
    };

    const handleCheckChange = (itemId, checked) => {
        const id = String(itemId);
        setChecklistData(prev => ({
            ...prev,
            [id]: {
                ...prev[id],
                checked: checked
            }
        }));
    };

    const handleTextareaChange = (itemId, text) => {
        const id = String(itemId);
        setChecklistData(prev => ({
            ...prev,
            [id]: {
                ...prev[id],
                reason: text
            }
        }));
    };

    // 특이사항 변경 핸들러
    const handleSpecialNotesChange = (e) => {
        setNotes(e.target.value);
    };

    // 파일 업로드 핸들러
    const handleFilesChange = (files) => {
        setUploadedFiles(files);
        console.log('선택된 파일들:', files);
    };

    const handleSubmit = async () => {
        if (uploadedFiles.length > 1) {
            showAlert('사진은 최대 1장까지 첨부 가능합니다.');
            return;
        }
        console.log('제출 직전 checklistData:', checklistData);

        const checklistArray = Object.entries(checklistData).map(([id, data]) => ({
            CHECK_ID: id,
            CHECKED: data.checked ? 'Y' : 'N',
            REASON: data.reason || '',
        }));

        console.log('제출 직전 checklistArray:', checklistArray);

        const formData = new FormData();
        formData.append('TAGNUM', tagnum);
        formData.append('NOTES', notes);
        formData.append('ADDR', ADDR);
        formData.append('userId', userId);
        formData.append('CHECKLIST', JSON.stringify(checklistArray));

        uploadedFiles.forEach((file) => {
            formData.append('images', file);
        });

        try {
            for (let pair of formData.entries()) {
                console.log(pair[0], pair[1]);
            }
            const res = await apiRequest('/submitChecklist', 'POST', {__IS_FORMDATA__: true, formData,userId:userId});

            if (res.success) {
                showAlert('제출이 완료되었습니다.');
                navigate('/patrolList', {state: {tagnum}});
            } else {
                showAlert('제출 실패: ' + (res.message || '서버 오류'));
            }
        } catch (error) {
            console.error('제출 오류:', error);
            showAlert('제출 중 오류가 발생했습니다.');
        }
    };

    return (
        <div className='mobile-container'>
            <div className="margin-top-section"/>

            <div className='tap-button-wrapper'>
                <p className='large-text gmarket-font'>점검사항</p>

                {checklistItems.map((item) => {
                    const itemKey = String(item.id);

                    return (
                        <TapButton
                            key={item.id}
                            hasTextarea={item.hasTextarea}
                            showReasonText={item.showReasonText}
                            isChecked={checklistData[itemKey]?.checked || false}
                            textareaProps={item.hasTextarea ? {
                                rows: 4,
                                autosize: true,
                                minRows: 2,
                                maxRows: 6,
                                value: checklistData[itemKey]?.reason || '',
                                onChange: (e) => handleTextareaChange(itemKey, e.target.value)
                            } : undefined}
                            onChange={(checked) => handleCheckChange(itemKey, checked)}
                        >
                            {item.content}
                        </TapButton>
                    );
                })}

            </div>

            <div className='textarea-wrapper'>
                <p className='large-text gmarket-font'>특이사항</p>
                <Textarea
                    placeholder="특이사항을 입력해주세요."
                    rows={3}
                    value={notes}
                    onChange={handleSpecialNotesChange}
                    styles={{
                        input: {
                            borderRadius: '10px',
                            border: '1px solid #F9F9F9',
                            background: '#F9F9F9',
                            fontSize: '12px',
                            color: '#333',
                            height: '80px',
                            marginTop: '10px'
                        }
                    }}
                />
            </div>

            <div className='upload-wrapper'>
                <p className='large-text gmarket-font'>사진첨부</p>
                <div className="small-margin-section"/>
                <ImageUploader onFilesChange={handleFilesChange}/>
            </div>

            <div className="button-wrapper">
                <Button className="bottom-button">
                    <a href="tel:112" className="bottom-button" style={{textAlign: 'center'}}>
                        비상연락
                    </a>
                </Button>
                <Button className="bottom-button" onClick={handleSubmit}>제출</Button>
            </div>

            <div className="margin-bottom-section"/>

            <Alert
                isOpen={alertState.isOpen}
                message={alertState.message}
                onConfirm={closeAlert}
            />
        </div>
    );
};

export default Checklist;
